import React, {type ReactNode} from 'react'
import XMarkIcon from '@images/x-mark.svg?react'
import {iconButtonClass, panelTitleClass} from '@/Layouts/dock'

interface Props {
    /** The heading, or an element (the SDK's channel header) that takes its place. */
    title: ReactNode
    leading?: ReactNode
    trailing?: ReactNode
    /** Close; the chat page's columns have none. */
    onClose?: () => void
}

/**
 * The chat bar the docked panel (ENG-4739) and the chat page's columns (ENG-4740) draw: anything leading, the
 * title, anything trailing, then Close when there is one. It anchors the staff pickers' popovers, which span the bar
 * so they stay inside the panel or column (ENG-4752).
 */
const ChatPanelHeader = ({title, leading, trailing, onClose}: Props): ReactNode => (
    <div className="relative flex items-center gap-1 border-b border-storm-80 py-2 pr-2 pl-2">
        {leading}
        <div className="min-w-0 flex-1">
            {typeof title === 'string'
                ? <h2 className={`pl-2 ${panelTitleClass}`}>{title}</h2>
                : title}
        </div>
        {trailing}
        {onClose !== undefined && (
            <button type="button" data-testid="chat-close" title="Close" className={iconButtonClass} onClick={onClose}>
                <span aria-hidden="true">
                    <XMarkIcon className="size-5"/>
                </span>
                <span className="sr-only">Close chat</span>
            </button>
        )}
    </div>
)

export default ChatPanelHeader
